// Standard carousel content
var carouselSlider = function(element) {
    // Defaults to true so undefined should be true
    var autoplay = element.data('autoplay') == undefined || element.data('autoplay') == 'true';
    var target = element.find('.carousel__container');

    target.slick({
        dots: true,
        nextArrow: arrow('next', 'icon-arrow-right'),
        prevArrow: arrow('prev', 'icon-arrow-left'),
        autoplay: autoplay,
        autoplaySpeed: 4000,
        speed: 1100
    });

    function arrow(dir, icon) {
        return '<button class="slick-arrow slick-' + dir + '">' +
            '<svg class="' + icon + '">' +
                '<use xlink:href="/images/svg-symbols.svg' + window.cacheBust + '#' + icon + '" />' +
            '</svg>' +
            '</button>';
    }
};

$(function() {
    $('.js-carousel').each(function() {
        carouselSlider($( this ));
    });
});

// Grid carousel content (grid items that become a carousel on mobile)
$(function() {

    var className = 'grid-carousel';
    var target = $('.accordion--has-carousel .grid');

    var breakpoint = 750;

        // Init the carousel
    function init() {
        target.slick({
            dots: false,
            arrows: false,
            centerMode: true,
            variableWidth: true,
            mobileFirst: true,
            responsive: [{
                breakpoint: breakpoint,
                settings: 'unslick'
            }]
        });
    }

    // Reinit the carousel (after changing breakpoint)
    function reInit() {
        var resize;
        $(window).on('resize.' + className, function() {
            clearTimeout(resize);
            resize = setTimeout(function() {
                if (window.matchMedia('(max-width : ' + breakpoint + 'px)').matches) {
                    init();
                    $(window).off('resize.' + className);
                }
            }, 100);
        });
    }

    // Init the carousel
    init();

    // If we start at the small breakpoint, we need to be ready to reinit for the large breakpoint
    if (window.matchMedia('(min-width : ' + breakpoint + 'px)').matches) {
        reInit();
    }

    // If we destroy the carousel, we need to be ready to reinit
    target.on('destroy', function(e, slick) {
        reInit();
    });
});

// School collecion carousel
$(function() {
    $('.js-school-carousel').each(function() {
        // Defaults to true so undefined should be true
        var target = $(this).find('.carousel__container');

        target.slick({
            dots: true,
            nextArrow: arrow('next', 'icon-arrow-right'),
            prevArrow: arrow('prev', 'icon-arrow-left'),
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: 1140,
                    settings: {
                        slidesToShow: 2,
                        arrows: false,
                        centerMode: true

                    }
                },
                {
                    breakpoint: 750,
                    settings: {
                        slidesToShow: 1,
                        arrows: false,
                        centerMode: true
                    }
                }
            ]
        });

        function arrow(dir, icon) {
            return '<button class="slick-arrow slick-' + dir + '">' +
                '<svg class="' + icon + '">' +
                    '<use xlink:href="/images/svg-symbols.svg' + window.cacheBust + '#' + icon + '" />' +
                '</svg>' +
                '</button>';
        }
    });
});
